// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"53d53bdf","390":"78f552f4","828":"93de672e"}[chunkId] + ".chunk.js";
};